import { axios } from '@/plugins/axios';

import { GLAccountService } from './accounting';
import { CurrencyService } from './currency';
import { DepartmentService } from './department';
import { EmployeeService } from './employee';
import { FileLoaderService } from './fileloader';
import { HrDepartmentService } from './hr-department';
import { ItemService } from './item';
import { ItemCommercialTranslationService } from './itemcommercialtranslation';
import { MaintenanceService } from './maintenance';
import { PriceSnapshotService } from './pricesnapshot';
import { IProvider } from './provider.types';
import { QuoteService } from './quote';
import { QuoteServiceVariableService } from './quote-service-variable';
import {
  QuoteFreightTemplateService,
  QuotePaymentTermTemplateService,
  QuoteServiceTemplateService,
  QuoteTermTemplateService
} from './quotetemplate';
import { RequisitionService } from './requisition';
import { SalesRepService } from './sales-rep';
import { TimeOffService } from './timeoff';
import { TimeOffRequestService } from './timeoff-request';
import { TimeOffCalendarService } from './timeoff-calendar';
import { VendorService } from './vendor';
import { InventoryAdvancePaymentService } from './inventory-advance-payment';
import { PayrollChangeRequestService } from './payrollchangerequest';
import { ItemTagService } from './item-tag';
import { WorkgroupService } from './workgroup';
import { EmployeeTimeOffService } from './employee-timeoff';
import { EmployeeWorkgroupService } from './employee-workgroup';
import { VacationCarryOverRequestService } from './vacation-carry-over-request';
import { OvertimeRequestService } from './overtime-request';
import { EmployeeFormService } from './employee-form';
import { FormTemplateService } from './form-template';
import { QuotePaymentTermCodeService } from './quote-payment-term-code';
import { OrderService } from './order/order';
import { DocumentService } from './document/document';
import { PaymentRequisitionService } from './payment-requisition';
import { ContractService } from './contract/contract';
import { WorkflowService } from './workflow';
import { WorkflowFormService } from './workflow-form';
import { WorkflowFormTemplateService } from './workflow-form-template';
import { InvoiceService } from './invoice';
import { BankService } from './bank';
import { PaymentPlanService } from './payment-plan';
import { TaxService } from './tax';
import { TariffService } from './tariff';
import { HarmonizedSystemService } from './harmonized-system';
import { TariffMandatoryItemService } from './tariff-mandatory-item';

export const provider = (): IProvider => ({
  accounting: new GLAccountService(axios),
  bank: new BankService(axios),
  timeOffCalendar: new TimeOffCalendarService(axios),
  currency: new CurrencyService(axios),
  contract: new ContractService(axios),
  department: new DepartmentService(axios),
  document: new DocumentService(axios),
  employee: new EmployeeService(axios),
  employeeForm: new EmployeeFormService(axios),
  employeeTimeOff: new EmployeeTimeOffService(axios),
  employeeWorkgroup: new EmployeeWorkgroupService(axios),

  formTemplate: new FormTemplateService(axios),
  fileLoader: new FileLoaderService(axios),
  invoice: new InvoiceService(axios),
  item: new ItemService(axios),
  maintenance: new MaintenanceService(axios),
  itemCommercialTranslation: new ItemCommercialTranslationService(axios),
  itemTag: new ItemTagService(axios),
  hrDepartment: new HrDepartmentService(axios),
  overtimeRequest: new OvertimeRequestService(axios),
  priceSnapshot: new PriceSnapshotService(axios),
  paymentPlan: new PaymentPlanService(axios),
  inventoryAdvancePayment: new InventoryAdvancePaymentService(axios),
  paymentRequisition: new PaymentRequisitionService(axios),
  payrollChangeRequest: new PayrollChangeRequestService(axios),
  timeOff: new TimeOffService(axios),
  timeOffRequest: new TimeOffRequestService(axios),
  tax: new TaxService(axios),
  harmonizedSystem: new HarmonizedSystemService(axios),
  tariff: new TariffService(axios),
  tariffMandatoryItem: new TariffMandatoryItemService(axios),
  order: new OrderService(axios),

  // Quote Templates
  quoteFreightTemplate: new QuoteFreightTemplateService(axios),
  quotePaymentTermTemplate: new QuotePaymentTermTemplateService(axios),
  quotePaymentTermCode: new QuotePaymentTermCodeService(axios),
  quoteServiceTemplate: new QuoteServiceTemplateService(axios),
  // Quote service variable
  quoteServiceVariable: new QuoteServiceVariableService(axios),
  quoteTermTemplate: new QuoteTermTemplateService(axios),
  quote: new QuoteService(axios),
  requisition: new RequisitionService(axios),
  salesRep: new SalesRepService(axios),
  vendor: new VendorService(axios),
  vacationCarryOverRequest: new VacationCarryOverRequestService(axios),

  workgroup: new WorkgroupService(axios),
  workflow: new WorkflowService(axios),

  workflowForm: new WorkflowFormService(axios),
  workflowFormTemplate: new WorkflowFormTemplateService(axios)
});

const providerInstance = provider();
export default providerInstance;
